import { Component, OnInit } from "@angular/core";
import { ThemeOptions } from "../../../../../theme-options";
import { faFile } from "@fortawesome/free-regular-svg-icons";

@Component({
  selector: "app-drawer",
  templateUrl: "./drawer.component.html",
  standalone: false,
})
export class DrawerComponent implements OnInit {
  faFile = faFile;
  toggleDrawer() {
    this.globals.toggleDrawer = !this.globals.toggleDrawer;
  }

  constructor(public globals: ThemeOptions) {}

  ngOnInit() {}
}
